module.exports = __webpack_public_path__ + "img/photo-analysis-article-icon.26ccdf87.svg";